/**
 * Universal Commands - Exports
 * 
 * These commands work with ANY v2 entity (Docs, Canvas, Sheets, etc.)
 * They provide a universal interface for AI interaction
 * 
 * 🔐 SECURITY: Some commands are restricted based on user role/environment
 */

import useUserStore from '../../stores/userStore';

export { entity_read } from './entity_read';
export { entity_write } from './entity_write'; // ⚠️ DEPRECATED - Use specialized tools instead
export { transcript_create } from './transcript_create';
// export { entity_search } from './entity_search'; // DISABLED
export { entity_format } from './entity_format';
export { page_read } from './page_read';
export { bookWriteCommand as book_write } from '../BookFormatterApp_v2/commands/book_write';
export { entity_format_clear } from './entity_format_clear';
export { entity_add_comment } from './entity_add_comment';
export { entity_get_metadata } from './entity_get_metadata';
export { entity_replace_all } from './entity_replace_all';
export { entity_open } from './entity_open';
export { image_add } from './image_add';
export { image_create } from './image_create';
export { x_search } from './x_search';
// export { unsplash_add } from './unsplash_add'; // DEPRECATED - Use image_add instead
// export { vlm_analyze } from './vlm_analyze'; // DISABLED - Adding slideNumber parameter
export { code_execute } from './code_execute';

export { semantic_scholar_search } from './semantic_scholar_search';
export { dropbox_search } from './dropbox_search';
export { dropbox_read } from './dropbox_read';
export { slack_find_user } from './slack_find_user';
export { slack_list_dms } from './slack_list_dms';
export { slack_read_dm } from './slack_read_dm';
export { slack_send_dm } from './slack_send_dm';
export { google_analytics_query } from './google_analytics_query';
export { google_ads_query } from './google_ads_query';
export { google_ads_mutate } from './google_ads_mutate';
export { gdrive_search } from './gdrive_search';
export { gdrive_read } from './gdrive_read';
export { gdrive_import } from './gdrive_import';
export { gdrive_convert } from './gdrive_convert';
export { google_books_search } from './google_books_search';
export { email_read } from './email_read';
export { calendar_read } from './calendar_read';
export { plan_read } from './plan_read';
export { plan_write_state } from './plan_write_state';
export { plan_append_log } from './plan_append_log';
export { tasks_read } from './tasks_read';
export { tasks_write } from './tasks_write';
export { table_create } from './table_create';
export { table_get } from './table_get';
export { table_update } from './table_update';
export { table_add_column } from './table_add_column';
export { table_remove_column } from './table_remove_column';
export { table_add_row } from './table_add_row';
export { table_update_cell } from './table_update_cell';
export { table_delete_row } from './table_delete_row';
export { table_link_entity } from './table_link_entity';
export { table_unlink_entity } from './table_unlink_entity';
export { table_query } from './table_query';
export { contacts_create } from './contacts_create';
export { contacts_find } from './contacts_find';
export { contacts_update } from './contacts_update';
export { contacts_import_csv } from './contacts_import_csv';
export { send_sms } from './send_sms';

import { entity_read } from './entity_read';
import { entity_write } from './entity_write'; // ⚠️ DEPRECATED - Use specialized tools instead
// import { entity_search } from './entity_search'; // DISABLED
import { entity_format } from './entity_format';
import { transcript_create } from './transcript_create';
import { page_read } from './page_read';
import { bookWriteCommand as book_write } from '../BookFormatterApp_v2/commands/book_write';
import { entity_format_clear } from './entity_format_clear';
import { entity_add_comment } from './entity_add_comment';
import { entity_get_metadata } from './entity_get_metadata';
import { entity_replace_all } from './entity_replace_all';
import { entity_open } from './entity_open';
import { image_add } from './image_add';
import { image_create } from './image_create';
import { x_search } from './x_search';
// import { unsplash_add } from './unsplash_add'; // DEPRECATED - Use image_add instead
// import { vlm_analyze } from './vlm_analyze'; // DISABLED - Adding slideNumber parameter
import { code_execute } from './code_execute';

import { semantic_scholar_search } from './semantic_scholar_search';
import { dropbox_search } from './dropbox_search';
import { dropbox_read } from './dropbox_read';
import { google_analytics_query } from './google_analytics_query';
import { google_ads_query } from './google_ads_query';
import { google_ads_mutate } from './google_ads_mutate';
import { gdrive_search } from './gdrive_search';
import { gdrive_read } from './gdrive_read';
import { gdrive_import } from './gdrive_import';
import { gdrive_convert } from './gdrive_convert';
import { google_books_search } from './google_books_search';
import { email_read } from './email_read';
import { calendar_read } from './calendar_read';
import { plan_read } from './plan_read';
import { plan_write_state } from './plan_write_state';
import { plan_append_log } from './plan_append_log';
import { tasks_read } from './tasks_read';
import { tasks_write } from './tasks_write';
import { table_create } from './table_create';
import { table_get } from './table_get';
import { table_update } from './table_update';
import { table_add_column } from './table_add_column';
import { table_remove_column } from './table_remove_column';
import { table_add_row } from './table_add_row';
import { table_update_cell } from './table_update_cell';
import { table_delete_row } from './table_delete_row';
import { table_link_entity } from './table_link_entity';
import { table_unlink_entity } from './table_unlink_entity';
import { table_query } from './table_query';
import { contacts_create } from './contacts_create';
import { contacts_find } from './contacts_find';
import { contacts_update } from './contacts_update';
import { contacts_import_csv } from './contacts_import_csv';
import { send_sms } from './send_sms';
import { slack_find_user } from './slack_find_user';
import { slack_list_dms } from './slack_list_dms';
import { slack_read_dm } from './slack_read_dm';
import { slack_send_dm } from './slack_send_dm';

/**
 * 🔐 Check if code_execute should be enabled
 * Only available for:
 * - Admins (in production)
 * - Any user on localhost
 * 
 * ⚠️ NOTE: On module load, admin status might not be fetched yet.
 * Localhost check works immediately. Admin check depends on fetchAdminStatus() being called.
 * This is OK because:
 * 1. Localhost users will always have access (safe for development)
 * 2. Admin users will get access once status loads (slight delay, but backend blocks non-admins anyway)
 * 3. Non-admin users in production won't see it (correct behavior)
 */
export function shouldEnableCodeExecute(): boolean {
  // Check if localhost FIRST (no async dependencies)
  if (typeof window !== 'undefined') {
    const isLocalhost = 
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';
    
    if (isLocalhost) {
      console.log('[UNIVERSAL_COMMANDS] 🏠 code_execute enabled for localhost');
      return true;
    }
  }
  
  // Check if admin (from userStore)
  // ⚠️ NOTE: isAdmin may be null during initial load (before fetchAdminStatus completes)
  const { isAdmin } = useUserStore.getState();
  
  if (isAdmin === true) {
    console.log('[UNIVERSAL_COMMANDS] 👑 code_execute enabled for admin');
    return true;
  }
  
  if (isAdmin === null) {
    console.log('[UNIVERSAL_COMMANDS] ⏳ code_execute disabled (admin status not loaded yet)');
  } else {
    console.log('[UNIVERSAL_COMMANDS] 🔒 code_execute disabled (not admin, not localhost)');
  }
  
  return false;
}

/**
 * Base universal commands (always available)
 */
const BASE_UNIVERSAL_COMMANDS = [
  entity_read,
  entity_write, // ⚠️ DEPRECATED - Kept for backward compatibility
  // entity_search, // DISABLED
  entity_format,
  transcript_create,
  entity_format_clear,
  entity_add_comment,
  entity_get_metadata,
  entity_replace_all,
  entity_open,
  page_read,
  book_write,

  image_add,
  image_create,
  x_search,
  // unsplash_add, // DEPRECATED - Use image_add instead
  // vlm_analyze, // DISABLED - Adding slideNumber parameter for specific slide capture
  semantic_scholar_search,
  dropbox_search,
  dropbox_read,
  google_analytics_query,
  google_ads_query,
  google_ads_mutate,
  gdrive_search,
  gdrive_read,
  gdrive_import,
  gdrive_convert,
  google_books_search,
  email_read,
  calendar_read,
  plan_read,
  plan_write_state,
  plan_append_log,
  tasks_read,
  tasks_write,
  table_create,
  table_get,
  table_update,
  table_add_column,
  table_remove_column,
  table_add_row,
  table_update_cell,
  table_delete_row,
  table_link_entity,
  table_unlink_entity,
  table_query,
  contacts_create,
  contacts_find,
  contacts_update,
  contacts_import_csv,
  send_sms,
  slack_find_user,
  slack_list_dms,
  slack_read_dm,
  slack_send_dm,
];

/**
 * Restricted commands (admin/localhost only)
 */
const RESTRICTED_COMMANDS = [
  code_execute  // 🔐 Code execution - admin/localhost only
];

/**
 * Array of all universal commands (dynamically filtered)
 * 
 * ⚠️ TIMING NOTE: This evaluates shouldEnableCodeExecute() at module load time.
 * - Localhost check works immediately ✅
 * - Admin check depends on userStore.isAdmin being set ⏳
 */
export const UNIVERSAL_COMMANDS = [
  ...BASE_UNIVERSAL_COMMANDS,
  ...(shouldEnableCodeExecute() ? RESTRICTED_COMMANDS : [])
];

export const UNIVERSAL_COMMAND_IDS = [
  // UC-only commands:
  'entity_write',         // ⚠️ DEPRECATED - kept for backward compat
  'entity_format',
  'entity_format_clear',
  'entity_add_comment',
  'entity_replace_all',
  'entity_open',
  'plan_read',
  'plan_write_state',
  'plan_append_log',
  'image_create',
  'x_search',
  ...(shouldEnableCodeExecute() ? ['code_execute'] : []), // 🔐 Conditional
  'semantic_scholar_search',
  'dropbox_search',
  'dropbox_read',
  'google_analytics_query',
  'google_ads_query',
  'google_ads_mutate',
  'gdrive_search',
  'gdrive_read',
  'gdrive_import',
  'gdrive_convert',
  'google_books_search',
  'email_read',
  'calendar_read'
];
